import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { CHANGELOG_LATEST_API_URL } from '@/config';

export type ChangelogLatest = {
  version: string;
  date: string;
  date_fa: string;
  url: string;
};

const changelogApi = createApi({
  reducerPath: 'changelogApi',
  baseQuery: fetchBaseQuery({ baseUrl: '' }),
  endpoints: build => ({
    getLatestChangelog: build.query<ChangelogLatest, void>({
      query: () => ({
        url: CHANGELOG_LATEST_API_URL,
        method: 'GET'
      })
    })
  })
});

export const { useGetLatestChangelogQuery } = changelogApi;

export default changelogApi;
